/* global G */
import { setKey } from 'lib/util'

/**
 * Clean Attribute Action State Hook
 *
 * Sets `attribute` in the current action's state to `null`.
 *
 * @param {string} attribute  the attribute to clean
 * @returns {function(...[*]): Promise<*[]>}
 */
export default attribute => obj => async (...args) => {
  try {
    const actionState = obj[G.STATE][G.ACTION][G.STATE]
    attribute && setKey(null, attribute, actionState)
  } catch (e) {
    console.error(e)
  }
  return args
}
